export default function (risks) {
  const risksKeys = Object.keys(risks).filter((key) => key.indexOf('Worker') === -1);
  let maximum = 0;
  risksKeys.forEach((key) => {
    if (risks[key] > maximum) maximum = risks[key];
  });
  return maximum ? Math.ceil((maximum + (maximum / 15)) / 5) * 5 : 0;
}
